import { NetworkPasswordComplexity } from '@tribeplatform/gql-client/types'
import { Form } from '@tribeplatform/react-sdk/components'
import { useNetwork, useUpdateNetwork } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { RadioGroup } from '@tribeplatform/react-ui-kit/RadioGroup'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

export const Security = () => {
  const { data: network } = useNetwork()
  const { mutateAsync: updateNetwork, isLoading } = useUpdateNetwork()
  return (
    <div className="max-w-3xl">
      <Card>
        <Card.Header title="Password strength" />
        <Card.Content>
          <p className="mb-5">
            As an admin, you can enforce password requirements to protect your
            users&apos; accounts and meet your organization&apos;s compliance
            needs. You can require a certain number of characters &amp; symbols
            for passwords.
          </p>
          <Form
            defaultValues={{ passwordComplexity: network?.passwordComplexity }}
            onSubmit={data => {
              updateNetwork({ input: data })
                .then(() => {
                  toast({
                    title: 'Security settings updated.',
                    status: 'success',
                  })
                })
                .catch(() => {
                  toast({
                    title: 'Unable to update security settings.',
                    status: 'error',
                  })
                })
            }}
          >
            <div className="col-span-12 md:col-span-8 flex flex-col space-y-5">
              <Form.RadioGroup name="passwordComplexity">
                <RadioGroup.Items>
                  <RadioGroup.Item
                    value={NetworkPasswordComplexity.SIMPLE}
                    title="Average"
                    description="Password should have 1 lowercase letter, 1 uppercase letter, 1 number, and be at least 8 characters long"
                  />
                  <RadioGroup.Item
                    value={NetworkPasswordComplexity.STANDARD}
                    title="Standard"
                    description={
                      <>
                        Password should have 1 lowercase letter, 1 uppercase
                        letter,{' '}
                        <span className="font-semibold">
                          1 special character
                        </span>
                        , and be at least 8 characters long
                      </>
                    }
                  />
                  <RadioGroup.Item
                    value={NetworkPasswordComplexity.COMPLEX}
                    title="Strong"
                    description={
                      <>
                        Password should have 1 lowercase letter, 1 uppercase
                        letter, 1 number,{' '}
                        <span className="font-semibold">
                          1 special character
                        </span>
                        , and be at least{' '}
                        <span className="font-semibold">
                          10 characters long
                        </span>
                      </>
                    }
                  />
                </RadioGroup.Items>
              </Form.RadioGroup>
              <p className="text-sm text-basicSurface-600 font-medium">
                These policies don&apos;t apply in some cases, such as when
                users are authenticated by a third party identity provider.
              </p>
              <Form.Actions>
                <Button type="submit" loading={isLoading}>
                  Update
                </Button>
              </Form.Actions>
            </div>
          </Form>
        </Card.Content>
      </Card>
    </div>
  )
}
